'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);

var _components = require('../../components');
var _Slider = require('./components/Slider');var _Slider2 = _interopRequireDefault(_Slider);

var _ProfessionalsCarousel = require('./ProfessionalsCarousel.scss');var styles = _interopRequireWildcard(_ProfessionalsCarousel);
var _getLocalizedData3 = require('../../utils/getLocalizedData');var _getLocalizedData4 = _interopRequireDefault(_getLocalizedData3);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
var ProfessionalsCarousel = function (_Component) {_inherits(ProfessionalsCarousel, _Component);function ProfessionalsCarousel() {var _temp, _this, _ret;_classCallCheck(this, ProfessionalsCarousel);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.








    setSliderRef = function (ref) {
      _this.sliderInst = ref;
    }, _this.

    handleClick = function (evt) {
      var id = (0, _get2.default)(evt, 'currentTarget.dataset.id');
      _this.props.handleClick(evt, id);
    }, _this.

    handleSlideChange = function () {
      if (_this.sliderInst) {
        var index = (0, _get2.default)(_this, 'sliderInst.swiper.activeIndex');
        if (index || index === 0) {
          _this.props.changeActiveIdx(index);
        }
      }
    }, _this.

    renderItem = function (professional, idx) {var
      id = professional.id,image = professional.image;var _getLocalizedData =
      (0, _getLocalizedData4.default)(professional.name, _this.props.locale),name = _getLocalizedData.result;var _getLocalizedData2 =
      (0, _getLocalizedData4.default)(professional.title, _this.props.locale),title = _getLocalizedData2.result;
      var logo = id === 'broker_community_cell' ? image : (0, _modifyImageLink2.default)(image, _constants.imageModifierTypes.PROFESSIONALS_SLIDER);

      // TODO Dirty hack instead broken lazy load
      var shouldLoadImage = idx < _this.props.activeIdx + (_this.props.isMobile ? 2 : 5);

      return (
        _react2.default.createElement('div', { key: id, 'data-id': id, className: styles.sliderItemWrapper, onClick: _this.handleClick },
          _react2.default.createElement(_components.ProfessionalCellSmall, {
            logo: shouldLoadImage ? logo : '',
            name: name,
            title: title })));



    }, _temp), _possibleConstructorReturn(_this, _ret);}ProfessionalsCarousel.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps) {var isLocaleChanged = newProps.locale !== this.props.locale;var isActiveSlideChanged = newProps.activeIdx !== this.props.activeIdx;var isScreenWidthChanged = newProps.screenWidth !== this.props.screenWidth;var isProfessionalsChanged = !(0, _isEqual2.default)(newProps.professionals, this.props.professionals);return isLocaleChanged || isProfessionalsChanged || isActiveSlideChanged || isScreenWidthChanged;};ProfessionalsCarousel.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_Slider2.default, {
          handleSlideChange: this.handleSlideChange,
          innerRef: this.setSliderRef,
          initialSlide: this.props.activeIdx,
          screenWidth: this.props.screenWidth },

        this.props.professionals.map(this.renderItem)));


  };return ProfessionalsCarousel;}(_react.Component);


ProfessionalsCarousel.propTypes = {
  screenWidth: _propTypes2.default.number,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  handleClick: _propTypes2.default.func,
  professionals: _propTypes2.default.array,
  activeIdx: _propTypes2.default.number,
  changeActiveIdx: _propTypes2.default.func };exports.default =


ProfessionalsCarousel;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfessionalsCarousel/ProfessionalsCarousel.js
// module id = 2802
// module chunks = 0